import * as actionTypes from './actionTypes';

export const initialState = {
  reports: [],
  reportsRangeToShow: [0, 10],
  filters: null,
  pagination: {
    current_page: 1,
    per_page: 10,
    total_items: 11,
  },
  spinner: null,
  isSkeleton: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_REPORTS: {
      return {
        ...state,
        reports: action.payload,
      };
    }
    case actionTypes.SET_CURRENT_PAGE: {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          current_page: action.payload,
        },
      };
    }
    case actionTypes.SET_INITIAL_STATE: {
      return initialState;
    }
    case actionTypes.SET_REPORTS_RANGE_TO_SHOW: {
      return {
        ...state,
        reportsRangeToShow: action.payload,
      };
    }
    case actionTypes.SET_REPORTS_FILTERED_BY_TYPE: {
      return {
        ...state,
        reportsTypeToShow: state?.reports.filter(({ type }) => type === action.payload),
      };
    }
    case actionTypes.SET_REPORTS_FILTERED_BY_RANGE: {
      return {
        ...state,
        reportsTypeToShow: action.payload,
      };
    }
    case actionTypes.DELETE_REPORT: {
      return {
        ...state,
        reports: state?.reports.filter(({ _id }) => _id !== action.payload),
      };
    }
    case actionTypes.OPEN_NEW_REPORT_MODAL: {
      return {
        ...state,
        newReportModal: 'start',
      };
    }
    case actionTypes.CLOSE_NEW_REPORT_MODAL: {
      return {
        ...state,
        newReportModal: 'end',
      };
    }
    case actionTypes.OPEN_LOAD_SPINNER: {
      return {
        ...state,
        spinner: true,
      };
    }
    case actionTypes.CLOSE_LOAD_SPINNER: {
      return {
        ...state,
        spinner: false,
      };
    }
    case actionTypes.SET_FILTER_REPORT: {
      return {
        ...state,
        filters: action.payload,
      };
    }

    case actionTypes.RESET_FILTER_REPORT: {
      return {
        ...state,
        filters: null,
        reportsTypeToShow: null,
      };
    }

    case actionTypes.SHOW_ON_SKELETON:
      return {
        ...state,
        isSkeleton: true,
      };

    case actionTypes.HIDE_ON_SKELETON:
      return {
        ...state,
        isSkeleton: false,
      };

    default:
      return {
        ...state,
      };
  }
};
